import {CSSProperties, MouseEventHandler, PropsWithChildren, ReactNode, TouchEventHandler} from "react";
import {css, cx} from "@panda/css";

import {Divider} from "../Divider";
import {bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle, bottomSheetSlideInStyle, bottomSheetSlideOutStyle} from "./styles/bottom_sheet_motion";
import {getEnterExitClass} from "./utils/get_enter_exit_class";

interface ISwipeHandlers {
    onTouchEnd?: TouchEventHandler;
    onTouchMove?: TouchEventHandler;
    onTouchStart?: TouchEventHandler;
}

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isClosing: boolean;
    isEntering: boolean;
    motionStyle?: CSSProperties;
    onClick?: MouseEventHandler<HTMLDivElement>;
    role?: string;
    showDivider?: boolean;
    swipeHandlers?: ISwipeHandlers;
}

export const BottomSheetPanel = (props: IProps) => {
    const {ariaLabel, children, footer, header, isClosing, isEntering, motionStyle, onClick, role, showDivider = true, swipeHandlers} = props;

    return (
        <div
            aria-label={ariaLabel}
            className={cx(
                bottomSheetPanelStyle,
                getEnterExitClass(isClosing, isEntering, bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle),
                getEnterExitClass(isClosing, isEntering, bottomSheetSlideInStyle, bottomSheetSlideOutStyle)
            )}
            onClick={onClick}
            role={role}
            style={motionStyle}
        >
            <div className={bottomSheetHandleWrapStyle} {...swipeHandlers}>
                <div className={bottomSheetHandleStyle} />
            </div>
            {header && <div className={bottomSheetHeaderStyle}>{header}</div>}
            {showDivider && <Divider />}
            <div className={cx(bottomSheetItemsStyle, footer ? bottomSheetItemsWithFooterStyle : undefined)}>{children}</div>
            {footer && <div className={bottomSheetFooterStyle}>{footer}</div>}
        </div>
    );
};

const bottomSheetPanelStyle = css({
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-1)",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflow: "hidden",
    width: "100%",

    "@supports (height: 100svh)": {
        maxHeight: "90svh"
    }
});

const bottomSheetHeaderStyle = css({
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    pb: "1rem",
    px: 2
});

const bottomSheetHandleWrapStyle = css({
    alignItems: "center",
    cursor: "grab",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    pb: "1rem",
    pt: 1,
    touchAction: "none",
    width: "100%"
});

const bottomSheetHandleStyle = css({
    backgroundColor: "var(--colors-gray-500)",
    borderRadius: "9.9rem",
    height: "0.4rem",
    width: "6rem"
});

const bottomSheetFooterStyle = css({
    flexShrink: 0,
    pb: 3,
    pt: 2,
    px: 2
});

const bottomSheetItemsStyle = css({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: 0,
    overflowY: "auto",
    pb: 3,
    pt: 1
});

const bottomSheetItemsWithFooterStyle = css({
    pb: 1
});
import {CSSProperties, MouseEventHandler, PropsWithChildren, ReactNode, TouchEventHandler} from "react";
import {css, cx} from "@panda/css";

import {Divider} from "../Divider";
import {bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle, bottomSheetSlideInStyle, bottomSheetSlideOutStyle} from "./styles/bottom_sheet_motion";
import {getEnterExitClass} from "./utils/get_enter_exit_class";

interface ISwipeHandlers {
    onTouchEnd?: TouchEventHandler;
    onTouchMove?: TouchEventHandler;
    onTouchStart?: TouchEventHandler;
}

interface IProps extends PropsWithChildren {
    ariaLabel?: string;
    footer?: ReactNode;
    header?: ReactNode;
    isClosing: boolean;
    isEntering: boolean;
    motionStyle?: CSSProperties;
    onClick?: MouseEventHandler<HTMLDivElement>;
    role?: string;
    showDivider?: boolean;
    swipeHandlers?: ISwipeHandlers;
}

export const BottomSheetPanel = (props: IProps) => {
    const {ariaLabel, children, footer, header, isClosing, isEntering, motionStyle, onClick, role, showDivider = true, swipeHandlers} = props;

    return (
        <div
            aria-label={ariaLabel}
            className={cx(
                bottomSheetPanelStyle,
                getEnterExitClass(isClosing, isEntering, bottomSheetMotionEnterStyle, bottomSheetMotionExitStyle),
                getEnterExitClass(isClosing, isEntering, bottomSheetSlideInStyle, bottomSheetSlideOutStyle)
            )}
            onClick={onClick}
            role={role}
            style={motionStyle}
        >
            <div className={bottomSheetHandleWrapStyle} {...swipeHandlers}>
                <div className={bottomSheetHandleStyle} />
            </div>
            {header && <div className={bottomSheetHeaderStyle}>{header}</div>}
            {showDivider && <Divider />}
            <div className={cx(bottomSheetItemsStyle, footer ? bottomSheetItemsWithFooterStyle : undefined)}>{children}</div>
            {footer && <div className={bottomSheetFooterStyle}>{footer}</div>}
        </div>
    );
};

const bottomSheetPanelStyle = css({
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,
    boxShadow: "var(--shadow-1)",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflow: "hidden",
    width: "100%",

    "@supports (height: 100svh)": {
        maxHeight: "90svh"
    }
});

const bottomSheetHeaderStyle = css({
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    pb: "1rem",
    px: 2
});

const bottomSheetHandleWrapStyle = css({
    alignItems: "center",
    cursor: "grab",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    pb: "1rem",
    pt: 1,
    touchAction: "none",
    width: "100%"
});

const bottomSheetHandleStyle = css({
    backgroundColor: "var(--colors-gray-500)",
    borderRadius: "9.9rem",
    height: "0.4rem",
    width: "6rem"
});

const bottomSheetFooterStyle = css({
    flexShrink: 0,
    pb: 3,
    pt: 2,
    px: 2
});

const bottomSheetItemsStyle = css({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: 0,
    overflowY: "auto",
    pb: 3,
    pt: 1
});

const bottomSheetItemsWithFooterStyle = css({
    pb: 1
});
